module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/img/logo.png"),
      "width": "192"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Oops! Página não encontrada...")]), _vm._v(" "), _c('p', [_vm._v("\n    Verifique se você digitou o endereço corretamente.\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0139152"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/template/404.vue
// module id = 1566
// module chunks = 45